import styled from 'styled-components';
import {Box} from './Box';

export const Divider = styled(Box)`
  height: 1px;
  background-color: ${props => props.theme.borderPrimary};
`;
